import React, { useMemo, useEffect, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import { useNavigate } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Button } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { DeleteSpace, FetchSpaces, UpdateSpace } from "../../apis/Space";
import { AxiosError } from "axios";

const Space = () => {
  const [spaces, setSpaces] = useState([]);
  const [updateData, setUpdateData] = useState({
    spaceId: "",
    itemName: "",
    isChecked: true,
  });
  const [deleteData, setDeleteData] = useState({
    spaceId: "",
  });
  const [modal_standard, setModal_standard] = useState(false);
  const [modal_static, setModal_static] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [fileError, setFileError] = useState(false);
  const [iconPreview, setIconPreview] = useState(null);

  const tog_standard = () => setModal_standard((prev) => !prev);
  const tog_static = () => setModal_static((prev) => !prev);
  const navigate = useNavigate();

  const fetchSpaces = async () => {
    const response = await FetchSpaces();
    setSpaces(response.data.spaces);
  };
  useEffect(() => {
    fetchSpaces();
  }, []);

  const handleUpdate = async () => {
    try {
      const { spaceId, itemName, isChecked } = updateData;

      const formData = new FormData();
      formData.append("spaceId", spaceId);
      formData.append("itemName.en", itemName.en);
      formData.append("itemName.ar", itemName.ar);
      formData.append("status", isChecked ? "enabled" : "disabled");
      formData.append("icon", uploadedImage);

      const updatedSpace = await UpdateSpace(formData);
      if (updatedSpace) {
        toast.success("Space Updated Successfully");
        setModal_standard(false);
        fetchSpaces();
      } else {
        toast.error("Space Update Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const handleDelete = async () => {
    try {
      const { spaceId } = deleteData;

      const response = await DeleteSpace(spaceId);

      if (response) {
        toast.success("Space Deleted Successfully");
        setModal_static(false);
        fetchSpaces();
        navigate("/space");
      } else {
        toast.error("space Deletion Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "English Item Name",
        accessor: "itemName.en",
      },
      {
        Header: "Arabic Item Name",
        accessor: "itemName.ar",
      },
      {
        Header: "Icon",
        accessor: "icon",
        Cell: ({ value }) =>
          value ? (
            <img
              src={value}
              alt="icon"
              style={{
                maxWidth: 100,
                maxHeight: 100,
                objectFit: "contain",
              }}
            />
          ) : (
            "N/A"
          ),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (value === "enabled" ? "Active" : "Inactive"),
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ value }) => new Date(value).toLocaleDateString(),
      },

      {
        Header: "Action",
        accessor: "actions",
        Cell: ({ row }) => (
          <div>
            <Button
              color="primary"
              className="btn-icon"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil"></i>
            </Button>
            <Button
              color="danger"
              className="btn-icon"
              onClick={() => handleDeleteClick(row.original)}
            >
              <i className="mdi mdi-delete"></i>
            </Button>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const handleImageUpload = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setUploadedImage(null);
      setFileError(null);
      return;
    }

    const allowedTypes = ["image/svg+xml"];
    const maxSize = 0.5 * 1024 * 1024; // 524kb limit

    if (!allowedTypes.includes(file.type)) {
      setIconPreview(null);
      setUploadedImage(null);
      setFileError("Only SVG files are allowed.");
      return;
    }
    // Check the file size
    if (file.size > maxSize) {
      setIconPreview(null);
      setUploadedImage(null);
      setFileError("File size must be less than 524KB.");
      return;
    }
    const iconUrl = URL.createObjectURL(file);
    setIconPreview(iconUrl);

    setUploadedImage(file);
    setFileError(null);
  };

  const handleEditClick = (space) => {
    setUpdateData({
      spaceId: space._id,
      itemName: space.itemName,
      icon: space.icon,
      isChecked: space.status === "enabled",
    });
    setIconPreview(space.icon); // Set the icon preview to the current icon
    tog_standard(); // Open the modal
  };

  const handleDeleteClick = (space) => {
    setDeleteData({
      spaceId: space._id,
    });
    tog_static(); // Open the modal
  };
  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "space", link: "#" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0" fluid>
        <Breadcrumbs title="DATA TABLES" breadcrumbItems={breadcrumbItems} />
        <div className="p-6 flex flex-col gap-6 ">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button
              color="success"
              className="waves-effect waves-light me-1"
              onClick={() => navigate("/space/add")}
            >
              Add space
            </Button>
          </div>
          <TableContainer
            columns={columns || []}
            data={spaces || []}
            isPagination={false}
            // isGlobalFilter={false}
            iscustomPageSize={false}
            isBordered={false}
            customPageSize={10}
          />
        </div>
        {/* START: Modal EDIT  */}
        <Modal isOpen={modal_standard} toggle={tog_standard}>
          <ModalHeader toggle={() => setModal_standard(false)}>
            Modal Heading
          </ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={handleUpdate}>
              <div className="mb-3">
                <AvField
                  name="itemNameEn"
                  label="space Name In English"
                  placeholder="Type Something In English"
                  type="text"
                  errorMessage="Enter Name In English"
                  value={updateData.itemName.en}
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemName: {
                        en: e.target.value,
                        ar: updateData.itemName.ar,
                      },
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  name="itemNameAr"
                  label="space Name In Arabic"
                  placeholder="Type Something In Arabic"
                  type="text"
                  errorMessage="Enter Name In Arabic"
                  value={updateData.itemName.ar}
                  validate={{ required: { value: true } }}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemName: {
                        en: updateData.itemName.en,
                        ar: e.target.value,
                      },
                    })
                  }
                />
              </div>
              <div className="mb-3">
                {iconPreview && (
                  <img
                    src={iconPreview}
                    alt="Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "contain",
                    }}
                  />
                )}
                <AvField
                  name="icon"
                  type="file"
                  accept="image/svg+xml"
                  label="Upload an Icon (SVG only)"
                  onChange={handleImageUpload}
                  errorMessage={fileError || "Please upload an icon."}
                  validate={{
                    required: { value: true },
                    // Add a fake validator to make AvField always revalidate correctly
                    pattern: {
                      value: ".*",
                      errorMessage: fileError || "Please upload an icon.",
                    },
                  }}
                />
              </div>
              <h4 className="card-title">Status</h4>
              <div className="form-check form-switch mb-3" dir="ltr">
                <Input
                  type="checkbox"
                  className="form-check-input"
                  checked={updateData.isChecked}
                  onChange={() =>
                    setUpdateData({
                      ...updateData,
                      isChecked: !updateData.isChecked,
                    })
                  }
                  id="customSwitch1"
                  defaultChecked
                />

                <Label
                  className="form-check-label"
                  htmlFor="customSwitch1"
                  onClick={(e) => {
                    this.setState({ toggleSwitch: !this.state.toggleSwitch });
                  }}
                >
                  {updateData.isChecked ? "Active" : "Inactive"}
                </Label>
              </div>
            </AvForm>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={tog_standard}
              color="light"
              className="waves-effect"
            >
              Close
            </Button>
            <Button
              type="button"
              onClick={handleUpdate}
              color="primary"
              className="waves-effect waves-light"
            >
              Save Changes
            </Button>
          </ModalFooter>
        </Modal>
        {/* END: Modal EDIT  */}

        {/* START: Modal DELETE */}

        <Modal isOpen={modal_static} toggle={tog_static} backdrop="static">
          <ModalHeader toggle={() => setModal_static(false)}>
            Static Backdrop
          </ModalHeader>
          <ModalBody>
            <p>Are you sure you want to delete this space?</p>
            <ModalFooter>
              <Button type="button" color="light" onClick={tog_static}>
                Close
              </Button>
              <Button type="button" color="primary" onClick={handleDelete}>
                Save
              </Button>
            </ModalFooter>
          </ModalBody>
        </Modal>
        {/* END: Modal DELETE */}
      </Container>
      </div>
    </React.Fragment>
  );
};

export default Space;
